module.exports = __webpack_public_path__ + "static/img/photo-store-locator_xs.7ec357f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x-small/photo-store-locator_xs.jpg
// module id = 1xb8
// module chunks = 1